/* Cart: join MESMO Circle before checkout.
   The cart is redrawn after every change, so everything here works on whatever
   join box is on the page at that moment and repaints it after each redraw. */
(function () {
  'use strict';

  var PENDING = 'mesmo:join-pending';
  var typed = '';
  var asked = false;
  var busy = false;

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  /* An earlier version hid the box for good on a device that had joined; that note is cleared. */
  try {
    localStorage.removeItem('mesmo:joined');
  } catch (error) {
    /* nothing to clear */
  }

  var justJoined = false;

  function paint() {
    all('[data-cart-join]').forEach(function (box) {
      var form = box.querySelector('[data-join-form]');
      var done = box.querySelector('[data-join-done]');
      var input = box.querySelector('[data-join-email]');
      box.hidden = false;
      form.hidden = justJoined;
      done.hidden = !justJoined;
      if (!justJoined && input && input.value !== typed && document.activeElement !== input) input.value = typed;
      var error = box.querySelector('[data-join-error]');
      if (error && lastError && error.hidden) {
        error.textContent = lastError;
        error.hidden = false;
      }
    });
  }

  var lastError = '';

  function showError(box, message) {
    var error = box.querySelector('[data-join-error]');
    lastError = message || '';
    error.textContent = lastError;
    error.hidden = !lastError;
  }

  function valid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function root() {
    var value = (window.MESMO && window.MESMO.routes && window.MESMO.routes.root) || '/';
    return value.charAt(value.length - 1) === '/' ? value : value + '/';
  }

  /* Shopify only accepts the sign-up once its spam check is attached to the form, which it
     does when someone starts using a form. The real form is out of sight, so it is told here. */
  function bound(form) {
    return !!(form.dataset.hcaptchaBound || form.dataset.recaptchaBound);
  }

  function wake() {
    var form = document.querySelector('[data-join-real]');
    if (!form || bound(form)) return;
    form.querySelector('[data-join-real-email]').dispatchEvent(new Event('focusin', { bubbles: true }));
  }

  document.addEventListener('focusin', function (event) {
    if (event.target.matches && event.target.matches('[data-join-email]')) wake();
  });

  /* Saves the member through Shopify's own customer form, the same kind as in the footer.
     Shopify's spam check adds its answer to the form and then sends it. Sending is taken over
     here so it happens in the background and the cart stays open. When Shopify wants to ask
     "are you a robot?" first, that happens on a page of its own; what to do after coming back
     from it is kept for this tab only. */
  var failTimer = null;

  function forget() {
    try {
      sessionStorage.removeItem(PENDING);
      sessionStorage.removeItem(PENDING + ':scroll');
      sessionStorage.removeItem(PENDING + ':checked');
    } catch (error) {
      /* nothing to clear */
    }
  }

  function release() {
    busy = false;
    window.clearTimeout(failTimer);
    all('[data-join-submit], [data-join-continue]').forEach(function (button) {
      button.removeAttribute('aria-busy');
    });
  }

  /* Not saved in the background. Shopify's spam answer can be used once, so the form is not
     sent again: either Shopify's own "are you a robot?" page is opened, or the visitor is asked
     to try again. */
  function notSaved(response) {
    if (response && response.url && response.url.indexOf('/challenge') !== -1) {
      window.location.href = response.url;
      return;
    }
    forget();
    release();
    all('[data-cart-join]').forEach(function (box) {
      showError(box, box.getAttribute('data-failed'));
    });
  }

  function quietSend(form, thenCheckout) {
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok || response.url.indexOf('customer_posted=true') === -1) {
          notSaved(response);
          return;
        }
        forget();
        release();
        typed = '';
        justJoined = true;
        if (thenCheckout) {
          window.location.href = root() + 'checkout';
          return;
        }
        paint();
      })
      .catch(function () {
        notSaved(null);
      });
  }

  function join(box, thenCheckout) {
    var email = typed.trim();
    var form = document.querySelector('[data-join-real]');
    if (!valid(email) || !form) {
      showError(box, box.getAttribute(valid(email) ? 'data-failed' : 'data-invalid'));
      return;
    }
    if (busy) return;
    busy = true;
    showError(box, '');
    all('[data-join-submit], [data-join-continue]').forEach(function (button) {
      button.setAttribute('aria-busy', 'true');
    });
    try {
      sessionStorage.setItem(PENDING, thenCheckout ? 'checkout' : 'cart');
      sessionStorage.setItem(PENDING + ':scroll', String(window.scrollY || 0));
    } catch (error) {
      /* without it the member is still saved; only the confirmation is skipped */
    }
    form.querySelector('[data-join-real-email]').value = email;
    if (window.fetch && window.FormData) {
      form.submit = function () {
        quietSend(form, thenCheckout);
      };
    }
    wake();
    var tries = 0;
    (function send() {
      if (!bound(form) && tries < 30) {
        tries += 1;
        window.setTimeout(send, 200);
        return;
      }
      form.querySelector('[data-join-real-submit]').click();
      /* Still here after a while: the form was not sent */
      failTimer = window.setTimeout(function () {
        forget();
        release();
        all('[data-cart-join]').forEach(function (other) {
          showError(other, other.getAttribute('data-failed'));
        });
      }, 15000);
    })();
  }

  /* Shopify sometimes asks "are you a robot?" on a page of its own before it saves the member.
     Nothing is done there, so the check stays in view; the answer follows on the next page. */
  function onChallenge() {
    return window.location.pathname.indexOf('/challenge') !== -1;
  }

  function cleanAddress() {
    if (!window.history || !window.history.replaceState) return;
    var query = window.location.search
      .replace(/^\?/, '')
      .split('&')
      .filter(function (part) {
        return part && part.indexOf('customer_posted=') !== 0;
      })
      .join('&');
    window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
  }

  /* After the reload: confirm, and reopen the cart or go on to checkout. */
  function afterReload() {
    var pending = null;
    var scroll = 0;
    var checked = false;
    try {
      pending = sessionStorage.getItem(PENDING);
      if (!pending) return;
      if (onChallenge()) {
        sessionStorage.setItem(PENDING + ':checked', '1');
        return;
      }
      scroll = Number(sessionStorage.getItem(PENDING + ':scroll')) || 0;
      checked = sessionStorage.getItem(PENDING + ':checked') === '1';
      sessionStorage.removeItem(PENDING);
      sessionStorage.removeItem(PENDING + ':scroll');
      sessionStorage.removeItem(PENDING + ':checked');
    } catch (error) {
      return;
    }
    var posted = window.location.search.indexOf('customer_posted=true') !== -1;
    if (posted) {
      justJoined = true;
      cleanAddress();
      if (pending === 'checkout') {
        window.location.href = root() + 'checkout';
        return;
      }
    }
    function finish() {
      var mark = document.querySelector('[data-join-real] [data-join-rejected]');
      var rejected = mark ? mark.getAttribute('data-join-rejected') : null;
      /* Left the robot check without finishing it: say nothing */
      if (!posted && !rejected && checked) return;
      window.scrollTo(0, scroll);
      var opener = document.querySelector('[data-cart-open]');
      if (opener && !document.querySelector('.cart--page')) opener.click();
      if (posted) return;
      window.setTimeout(function () {
        all('[data-cart-join]').forEach(function (box) {
          showError(box, box.getAttribute(rejected === 'email' ? 'data-known' : 'data-failed'));
        });
      }, 400);
    }
    if (document.readyState === 'complete') finish();
    else window.addEventListener('load', finish);
  }

  function goToCheckout(box) {
    asked = true;
    var scope = box.closest('[data-cart-contents]') || document;
    var button = scope.querySelector('button[name="checkout"]');
    if (button) button.click();
  }

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-join-email]')) return;
    typed = input.value;
    asked = false;
  });

  document.addEventListener('keydown', function (event) {
    var input = event.target;
    if (event.key !== 'Enter' || !input.matches || !input.matches('[data-join-email]')) return;
    event.preventDefault();
    join(input.closest('[data-cart-join]'), false);
  });

  document.addEventListener('click', function (event) {
    var target = event.target.closest ? event.target.closest('button') : null;
    if (!target) return;
    var box = target.closest('[data-cart-join]');
    if (target.matches('[data-join-submit]')) {
      join(box, false);
    } else if (target.matches('[data-join-continue]')) {
      join(box, true);
    } else if (target.matches('[data-join-skip]')) {
      goToCheckout(box);
    }
  });

  /* Someone typed an email address but goes to checkout without joining: ask once. */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest ? event.target.closest('button[name="checkout"]') : null;
      if (!button || asked || justJoined || !typed.trim()) return;
      var scope = button.closest('[data-cart-contents]') || document;
      var box = scope.querySelector('[data-cart-join]');
      if (!box || box.hidden) return;
      event.preventDefault();
      event.stopPropagation();
      asked = true;
      box.querySelector('[data-join-ask]').hidden = false;
      box.querySelector('[data-join-continue]').focus();
    },
    true
  );

  /* Repaint after the cart is redrawn */
  function watch() {
    all('[data-cart-contents]').forEach(function (contents) {
      new MutationObserver(paint).observe(contents, { childList: true });
    });
    paint();
  }

  afterReload();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
